export default __webpack_public_path__ + "OverviewEnergyDrawingImage.png";